import { Component, OnInit, Input } from '@angular/core';
import { CustomerService } from '../../customer.service';
import { OrderService } from '../../order.service';
import { OrderDTO } from '../../../../../shared/order-dto';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountDTO } from '../../../../../shared/account-dto';
import { AccountService } from '../../account.service';

@Component({
  selector: 'pv-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {
  @Input() urlToken: string;
  loggedIn: boolean;
  authorized: boolean;
  order: OrderDTO;
  loading: boolean = true;
  isWholesale = false;
  changingAddress = false;
  address = null;
  account: AccountDTO = { } as AccountDTO

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService,
    private orderService: OrderService,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    // Subscribe to account
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)
    this.loggedIn = this.customerService.loggedIn;
    this.customerService.loginSubject.subscribe(loggedIn => this.loggedIn = loggedIn)
    if (this.urlToken) {
      this.loadOrder(this.urlToken)
    } else {
      this.route.params.subscribe(params => {
        this.authorized = false;
        this.loadOrder(params.url_token)
      })
    }

    this.isWholesale = this.customerService.checkoutDTO.customer.is_wholesale
  }

  loadOrder(url_token) {
    this.loading = true;
    this.orderService.getOrderByToken(url_token)
    .subscribe(order => {
      this.order = order
      this.authorized = order.customer_id == this.customerService.checkoutDTO.customer.id || order.shippingAddress.email == this.customerService.checkoutDTO.customer.email
      this.loading = false;
    }, err => {
      this.router.navigate(['/'])
    })
  }

  getDiscount() {
    return -1 * this.order.items.reduce((sum, item) => sum + (item.original_price - item.sold_price), 0)
  }

  onAddressChange(data) {
    if (data) {
      this.address = {
        firstname: data.ship_firstname,
        lastname: data.ship_lastname,
        addr1: data.ship_addr1,
        addr2: data.ship_addr2,
        city: data.ship_city,
        state: data.ship_state,
        zip: data.ship_zip,
        country_iso: data.ship_country_iso,
        company: data.company,
        phone: data.ship_phone,
      }
    } else {
      this.address = null;
    }
  }

  saveAddress() {
    this.loading = true;
    this.orderService.updateAddress(this.order.id, this.address)
    .subscribe(order => {
      this.loading = false;
      this.changingAddress = false;
      this.order = order
    })
  }

  editOrder() {
    this.customerService.editOrder(this.order.id)
    .subscribe(async x => {
      (await this.customerService.fetchCart()).subscribe(x => console.log(x))
      this.router.navigate(['/cart'])
    })
  }
}
